import { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios'
import { getENVData } from '@/configs/enviornment'
import axiosInstance from '@/services/axiosInstance/axiosInstance'

export type PostOptions =
  | ({
      skipHeader?: boolean
    } & AxiosRequestConfig<Record<string, unknown>>)
  | undefined

export interface ErrorRes {
  data: unknown
}

const getBaseUrl = (options: PostOptions) => {
  if (options?.skipHeader) {
    return getENVData().baseURL
  } else return getENVData().baseURL + '/management'
}

export async function post(
  url: string,
  payload: Record<string, unknown> = {},
  options?: PostOptions,
): Promise<Record<string, unknown> | ErrorRes> {
  try {
    const response: AxiosResponse<Record<string, unknown>> =
      await axiosInstance.post(getBaseUrl(options) + url, payload, {
        ...options,
        signal: options?.signal,
      })
    console.log(response, 'respoenseee')

    return response
  } catch (err) {
    const error = err as AxiosError
    console.log(error, 'trgtrgtrgerfre')
    const data: ErrorRes = {
      data: {
        url: getENVData().baseURL + url,
        path: url,
        status: error?.response?.status || 'not available',
        payload,
        code: error.code,
        message: error.message,
        backendError: error.response?.data,
      },
    }
    return data
  }
}

export async function get(
  url: string,
  _options: PostOptions = {},
): Promise<Record<string, unknown> | ErrorRes> {
  try {
    const response: AxiosResponse<Record<string, unknown>> =
      await axiosInstance.get(getBaseUrl(_options) + url, _options)

    return response
  } catch (err) {
    const error = err as AxiosError
    const data: ErrorRes = {
      data: {
        url: getENVData().baseURL + url,
        path: url,
        status: error?.response?.status || 'not available',
        code: error.code,
        message: error.message,
      },
    }
    return data
  }
}

export async function patch<PatchRes>(
  url: string,
  payload: Record<string, unknown> = {},
): Promise<PatchRes | ErrorRes> {
  try {
    const response = await axiosInstance.patch<PatchRes>(
      getENVData().baseURL + url,
      payload,
    )
    return response
  } catch (err) {
    const error = err as AxiosError
    const data = {
      status: error?.response?.status || 'not available',
      data: error?.response?.data,
      message: error?.message,
    }
    console.error('DELETE Error', {
      url: getENVData().baseURL + url,
      path: url,
      status: error?.response?.status,
      payload,
      code: error.code,
      message: error.message,
    })
    return data
  }
}

export async function remove<DeleteRes>(
  url: string,
  payload?: Record<string, unknown>,
): Promise<DeleteRes | ErrorRes> {
  const result: DeleteRes | ErrorRes = await axiosInstance
    .delete(getENVData().baseURL + url, { data: payload })
    .then(response => {
      return response.data
    })
    .catch(err => {
      const data = {
        status: err.response?.status || 'not available',
        data: err.response?.data,
        message: err.message,
      }
      console.error('DELETE Error', {
        url: getENVData().baseURL + url,
        path: url,
        status: err.response?.status,
        code: err.code,
        message: err.message,
      })
      return data
    })
  return result
}
